export default __webpack_public_path__ + "static/media/favicon.fd2cc731.png";